// src/components/Team/Team.jsx
import { useState } from "react";
import "./Team.css";

const IMAGE_BASE = "https://unionafricaceuti.com/img/jugadores/";

// Código de nacionalidad -> bandera
const NATIONALITY_FLAG = {
  ES: "🇪🇸",
  AR: "🇦🇷",
  BR: "🇧🇷",
  FR: "🇫🇷",
};

const getFlag = (code) => NATIONALITY_FLAG[code] ?? "";

// Jugadores
const players = [
  { file: "MarioGomezHernandez.png",            number: 1,  position: "Portero", nationality: "ES" },
  { file: "VictorManuelArevaloCarillo.png",     number: 3,  position: "Cierre",  nationality: "ES" },
  { file: "JaviGonzalezRodriguez.png",          number: 4,  position: "Ala",     nationality: "ES" },
  { file: "NachoTorresSalazar.png",             number: 5,  position: "Ala",     nationality: "ES" },
  { file: "AminMadjidBenslama.png",             number: 7,  position: "Ala",     nationality: "FR" },
  { file: "AlvaroRuanoPrieto.png",              number: 8,  position: "Ala",     nationality: "ES" },
  { file: "AlejandroMoñinoGarcia.png",          number: 9,  position: "Pivot",   nationality: "ES" },
  { file: "DavidSeñoretTorres.png",             number: 10, position: "Ala",     nationality: "ES" },
  { file: "AlejandroGarciaMuñoz.png",           number: 17, position: "Ala",     nationality: "ES" },
  { file: "LucasAlejandroForasteiroLenial.png", number: 20, position: "Portero", nationality: "AR" },
  { file: "AlbertoGutierrezPatiño.png",         number: 21, position: "Portero", nationality: "ES" },
  { file: "MiguelAngelVicenteMartinez.png",     number: 24, position: "Pivot",   nationality: "ES" },
  { file: "AntónFraileTorra.png",               number: 27, position: "Ala",     nationality: "ES" },
  { file: "MarioCarrion.png",                   number: 30, position: "Ala",     nationality: "ES" },
  { file: "GustavoEnriqueDaSilvaBarbosa.png",   number: 50, position: "Cierre",  nationality: "BR" },
];

// Convierte "MarioGomezHernandez.png" -> "Mario Gomez Hernandez"
function fileToFullName(file) {
  const base = file.replace(/\.[^.]+$/, "");
  const parts = base.split(/(?=[A-ZÁÉÍÓÚÑ])/);
  return parts.join(" ");
}

const Team = () => {
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  const playersSorted = [...players].sort((a, b) => a.number - b.number);

  const openPlayer = (player) => {
    const fullName = fileToFullName(player.file);
    setSelectedPlayer({ ...player, fullName });
  };

  const closePlayer = () => setSelectedPlayer(null);

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 py-6 md:py-10">
        <h2 className="text-xl md:text-2xl font-semibold mb-6 text-white">
          1er equipo
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
          {playersSorted.map((player) => {
            const { file, number, position, nationality } = player;
            const fullName = fileToFullName(file);
            const flag = getFlag(nationality);

            return (
              <article
                key={file}
                className="player-card"
                data-number={number}
                onClick={() => openPlayer(player)}
              >
                <div className="player-photo">
                  <img
                    src={`${IMAGE_BASE}/${file}`}
                    alt={fullName}
                    className="player-img"
                  />
                </div>

                <div className="player-meta">
                  {/* Fila posición (izq) + bandera (dcha) */}
                  <div className="player-meta-row">
                    <span className="player-number-badge">
                      {position}
                    </span>
                    {flag && <span className="player-flag">{flag}</span>}
                  </div>

                  <p className="player-name">{fullName}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>

      {selectedPlayer && (
        <div className="player-modal-overlay" onClick={closePlayer}>
          <article
            className="player-modal-card"
            data-number={selectedPlayer.number}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="player-modal-close"
              onClick={closePlayer}
              aria-label="Cerrar ficha del jugador"
            >
              ×
            </button>

            <div className="player-modal-photo">
              <img
                src={`${IMAGE_BASE}/${selectedPlayer.file}`}
                alt={selectedPlayer.fullName}
                className="player-modal-img"
              />
            </div>

            <div className="player-modal-meta">
              <div className="player-modal-row">
                <span className="player-modal-position">
                  {selectedPlayer.position}
                </span>
                {getFlag(selectedPlayer.nationality) && (
                  <span className="player-flag">
                    {getFlag(selectedPlayer.nationality)}
                  </span>
                )}
              </div>

              <h3 className="player-modal-name">
                {selectedPlayer.fullName}
              </h3>

              <p className="player-modal-number">
                Dorsal {selectedPlayer.number}
              </p>
            </div>
          </article>
        </div>
      )}
    </section>
  );
};

export default Team;
